import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslationModel, ProductModel, Variant, EnvironmentDatabaseLevl2Option, ProductEnvironmentDatabase, ProductEnvironmentDatabaseLevel2 } from "../../models/product";

@Component
export default class ProductEnvironmentDataBaseModal extends Vue {

    protected vm: any = {};
    @Prop()
    protected environmentModel!: ProductEnvironmentDatabase;
    protected textdecoration: object = {} as object;
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.textdecoration = { "text-decoration": "none" };
    }

    protected hideModal() {
        this.$emit("close");
    }

    protected GetIndicatorValues(item: EnvironmentDatabaseLevl2Option[], indicator: string) {
        return item.map(x => {
            if (x.indicatorIdentifier === indicator) {
                return x;
            }
        });
    }

    protected GetAllIndicators(model: ProductEnvironmentDatabaseLevel2) {
        const options: EnvironmentDatabaseLevl2Option[] = [];
        model.allAvailableOptions.map(x => {
            if (!options.find(a => a.indicatorIdentifier === x.indicatorIdentifier)) {
                options.push(x);
            }
        });
        return options;
    }
}
